import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import React from "react";

function TestimonailSlider() {
    const settings = {
        infinite: true,
        dots: false,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            }
          ]
    };
  return (
    <>
     <section className="section-padding testimonial-wrap">
        <div className="testimonial-overlayer"></div>
        <div className="container">
            <Slider {...settings}>
                <div className="item">
                    <div className="inner">
                        <div className="thumb">
                            <img src="/tm/react/toolways/assets/images/testimonials/1.png" alt="img"/>
                        </div>
                        <div className="excert">
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                        </div>
                        <div className="info">
                            <i className="fa fa-quote-right" aria-hidden="true"></i>
                            <Link to="">Albert Einstine</Link>
                            <span>Manager</span>
                        </div>
                    </div>
                </div>
                <div className="item">
                    <div className="inner">
                        <div className="thumb">
                            <img src="/tm/react/toolways/assets/images/testimonials/1.jpg" alt="img"/>
                        </div>
                        <div className="excert">
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                        </div>
                        <div className="info">
                            <i className="fa fa-quote-right" aria-hidden="true"></i>
                            <Link to="">Albert Einstine</Link>
                            <span>Manager</span>
                        </div>
                    </div>
                </div>
                <div className="item">
                    <div className="inner">
                        <div className="thumb">
                            <img src="/tm/react/toolways/assets/images/testimonials/1.jpg" alt="img"/>
                        </div>
                        <div className="excert">
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                        </div>
                        <div className="info">
                            <i className="fa fa-quote-right" aria-hidden="true"></i>
                            <Link to="">Albert Einstine</Link>
                            <span>Manager</span>
                        </div>
                    </div>
                </div>
            </Slider>
        </div>
    </section>
    </>
  )
}

export default TestimonailSlider